import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
          customProperties: true,
      },
      themes: {
          light: {
            //   primary: '#1565c0',
              primary: '#2F6E83',
            //   secondary: '#2d394b',
              secondary: '#545f6d',

              na: '#757575',


          },
      },
  },
});
